/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Risk
 */
export interface Risk {
  /**
   *
   * @type {number}
   * @memberof Risk
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  scenarios?: string | null;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  readonly createdBy: string;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  readonly updatedBy: string;
  /**
   *
   * @type {Date}
   * @memberof Risk
   */
  readonly createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof Risk
   */
  readonly updatedAt: Date;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  readonly categories: string;
  /**
   *
   * @type {number}
   * @memberof Risk
   */
  category: number;
}

/**
 * Check if a given object implements the Risk interface.
 */
export function instanceOfRisk(value: object): value is Risk {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('title' in value) || value['title'] === undefined) return false;
  if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
  if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
  if (!('categories' in value) || value['categories'] === undefined) return false;
  if (!('category' in value) || value['category'] === undefined) return false;
  return true;
}

export function RiskFromJSON(json: any): Risk {
  return RiskFromJSONTyped(json, false);
}

export function RiskFromJSONTyped(json: any, ignoreDiscriminator: boolean): Risk {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    title: json['title'],
    description: json['description'] == null ? undefined : json['description'],
    scenarios: json['scenarios'] == null ? undefined : json['scenarios'],
    createdBy: json['created_by'],
    updatedBy: json['updated_by'],
    createdAt: new Date(json['created_at']),
    updatedAt: new Date(json['updated_at']),
    categories: json['categories'],
    category: json['category'],
  };
}

export function RiskToJSON(
  value?: Omit<Risk, 'id' | 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt' | 'categories'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    title: value['title'],
    description: value['description'],
    scenarios: value['scenarios'],
    category: value['category'],
  };
}
